import { OrganisationService } from "@js/services/OrganisationService";
import { EnterpriseService } from "@js/services/EnterpriseService";
import { AuthService } from "@js/services/AuthService";
import {
  ApplicationUser,
  Client,
  ClientClient,
  DealClient,
  HubspotContactRequest,
  LenderClient,
  LinkTypeEnum,
  Organisation,
  ProductFamilyEnum,
  SaveEnterpriseClientAndRenameSearchRequest,
  SaveEnterpriseClientAndRenameSearchResponse,
  UserClient,
  UserRoleEnum,
} from "@src/apis/ModularClient";
import ProductHelper from "@js/helpers/ProductHelper";
import { ODataHelper } from "@js/helpers/ODataHelper";
import { SharedCriteriaService } from "@js/services/Deal/SharedCriteriaService";

declare const window: Window & { dataLayer: any[] };

export class EnterpriseLeadCaptureController {
  loadingData: boolean = false;
  resultsCount: Number;
  enterpriseClient: ApplicationUser;
  password: string = null;
  projectName: string;
  errorMessage: string = "";
  emailExistsError: boolean = false;
  dealDetails: SaveEnterpriseClientAndRenameSearchResponse;
  showContactForm = false;
  orgCode: string;
  enterpriseLinkLogo: string;
  totalLenders: number = null;
  isWidget: boolean = false;
  isMobileView: boolean = false;
  iFrame: boolean = false;
  organisationLinkId: number = null;
  organisationLinkUniqueId: string = "";
  enterpriseLinkType: string;
  leadCaptureForm: ng.IFormController;
  showEnterpriseRegistrationModal: boolean = false;
  showRegisterModal: boolean = false;
  showLoginSection: boolean = false;

  // Logging in/resetting password
  isLoginError: boolean = false;
  isResetPasswordSubmitted: boolean = false;
  registrationLoginError: string = null;

  acceptTerms: boolean = false;

  hasEnterpriseClient: boolean = false;
  phoneNumber: number;
  newUrl: string;
  message: string;
  showMessageModal: boolean = false;
  organisation: Organisation;
  static $inject = [
    "$rootScope",
    "$routeParams",
    "$location",
    "$cookies",
    "OrganisationService",
    "DealClient",
    "UserClient",
    "LenderClient",
    "EnterpriseService",
    "AuthService",
    "$q",
    "ClientClient",
    "ODataHelper",
    "SharedCriteriaService",
  ];

  constructor(
    public $rootScope: ng.IRootScopeService,
    private $routeParams: ng.route.IRouteParamsService,
    private $location: ng.ILocationService,
    private $cookies: ng.cookies.ICookiesService,
    private organisationService: OrganisationService,
    private dealClient: DealClient,
    private userClient: UserClient,
    private lenderClient: LenderClient,
    private enterpriseService: EnterpriseService,
    private $auth: AuthService,
    protected $q: ng.IQService,
    private clientClient: ClientClient,
    private oDataHelper: ODataHelper,
    private sharedCriteriaService: SharedCriteriaService,
  ) {
    if (window.self == window.top) {
      this.orgCode = this.$cookies.get("org_code") ?? null;
    } else {
      this.orgCode = location.pathname.replace("/", "");
    }

    this.getSearchResultsCountByUniqueRefAndLogPageLoadEvent();

    /* if (window.self == window.top) {
      this.enterpriseLinkType = sessionStorage.getItem("enterpriseLinkType");
    } else {
      this.organisationService
        .getData("enterpriseLinkType")
        .then((linkType) => {
          if (linkType) {
            this.enterpriseLinkType = linkType;
          }
        })
        .catch((error) => {
          console.error("Failed to get user data: ", error);
        });
    }*/

    if (this.$routeParams.context == "widget" && window.self != window.top) {
      document.getElementById("footer").style.display = "none";
      this.isWidget = true;
    } else if (window.innerWidth <= 480 && window.self == window.top) {
      this.isMobileView = true;
    } else if (window.self != window.top) {
      this.iFrame = true;
    }
  }

  getNumberOfLenders() {
    this.lenderClient.getTotalLenders(ProductFamilyEnum.None, this.organisation.id).then((totalLenders: number) => {
      this.totalLenders = Math.floor(totalLenders / 5) * 5;

      const trustboxRef = document.getElementById("trustbox");

      if (trustboxRef && (window as any).Trustpilot) {
        (window as any).Trustpilot.loadFromElement(trustboxRef);
      }
    });
  }

  getSearchResultsCountByUniqueRefAndLogPageLoadEvent() {
    this.loadingData = true;
    this.errorMessage = "";
    this.dealClient
      .getSearchResultsCountByUniqueRefAndLogPageLoadEvent(this.$routeParams.uniqueRef, this.orgCode)
      .then((response) => {
        this.resultsCount = response.totalResultsCount;
        this.organisationLinkId = response.dealUniqueLinkId;
        this.organisationLinkUniqueId = response.dealUniqueLinkUniqeId;
        const imgs = document.getElementsByTagName("img");
        this.enterpriseLinkLogo =
          this.organisationLinkId != null && response.dealUniqueLinkLogoUrl
            ? response.dealUniqueLinkLogoUrl
            : imgs[0].src;
        this.projectName = response.dealName;
        this.organisation = response.organisation;
        this.getNumberOfLenders();

        if (response.enterpriseClient) {
          this.hasEnterpriseClient = true;
          this.enterpriseClient = {} as ApplicationUser;
          this.enterpriseClient.fullName = `${response.enterpriseClient.firstName} ${response.enterpriseClient.lastName}`;
          if (response.enterpriseClient.phoneNumber) this.phoneNumber = Number(response.enterpriseClient.phoneNumber);
          this.enterpriseClient.email = response.enterpriseClient.email;
        }
        this.showContactForm = true;
      })
      .catch((response) => {
        this.errorMessage = "Error while loading page, please try later.";
      })
      .finally(() => {
        this.loadingData = false;
      });
  }

  onViewLoansClicked() {
    this.loadingData = true;
    this.errorMessage = "";
    this.emailExistsError = false;
    this.userClient.isRegisteredUser(this.enterpriseClient.email).then((response) => {
      if (!response) {
        this.saveEnterpriseClientAndRenameDeal();
      } else {
        this.emailExistsError = true;
        this.loadingData = false;
      }
    });
  }

  saveEnterpriseClientAndRenameDeal(
    isLogin: boolean = false,
  ): ng.IPromise<SaveEnterpriseClientAndRenameSearchResponse> {
    const defer = this.$q.defer<SaveEnterpriseClientAndRenameSearchResponse>();
    const userFullName = this.enterpriseClient.fullName;
    const spaceIndex = userFullName.indexOf(" ");

    let firstName = "";
    let lastName = "";

    // if not space has been added to the name then put the whole name in the first name field
    if (spaceIndex == -1) {
      firstName = userFullName;
      lastName = userFullName;
    } else {
      firstName = userFullName.substring(0, userFullName.indexOf(" "));
      lastName = userFullName.substring(userFullName.indexOf(" ") + 1);
    }

    // Set up Client dto
    const clientDto: Client = {
      firstName: firstName,
      lastName: lastName,
      phoneNumber: this.phoneNumber?.toString(),
      email: this.enterpriseClient.email,
      postalAddress: {
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        addressLine4: "",
        postCode: "",
      },
    } as Client;

    const request: SaveEnterpriseClientAndRenameSearchRequest = {
      dealUniqueRef: this.$routeParams.uniqueRef,
      dealNewName: this.projectName,
      clientDto: clientDto,
      clientId: clientDto.id,
      isExistingClient: false,
      sourceUrl: this.sharedCriteriaService.getPreviousUrl(),
    };

    this.dealClient
      .saveEnterpriseClientAndRenameDeal(request)
      .then((response) => {
        if (response) {
          this.dealDetails = response;
          if (window.self == window.top) {
            sessionStorage.setItem("clientId", this.dealDetails.clientId.toString());
          } else {
            this.organisationService.sendDataToParent("clientId", this.dealDetails.clientId.toString());
          }

          // For Google analytics tracking
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "results_gating_form",
            loan_product_family: ProductHelper.getProductFamilyTextForGa(this.dealDetails.productFamily),
            loan_product_type: ProductHelper.getProductTypeTextForGa(
              this.dealDetails.productType,
              this.dealDetails.isFamilyInResidence,
            ),
          });

          if (!isLogin) {
            this.enterpriseClient.oidcId = "";
            this.enterpriseClient.name = "";
            this.enterpriseClient.userName = "";

            this.userClient.sendEventToHubspot({
              user: this.enterpriseClient,
              page: "ENTERPRISE-LEAD-DETAILS-COLLECTED",
              introducerString: "",
              login: false,
              orgCode: this.orgCode ?? "",
              role: UserRoleEnum.Client,
              organisationLinkId: this.dealDetails.organisationLinkId != null ? this.dealDetails.organisationLinkId : 0,
              productType: this.dealDetails.productType,
              dealId: this.dealDetails.dealId,
              developmentInputWithNoLoginUniqueRef: "",
              clientId: this.dealDetails.clientId,
              isDeleted: false,
            } as HubspotContactRequest);

            let resultPageurl = this.getResultsPageUrl();
            this.goToLink(resultPageurl, true);
          }

          defer.resolve(response as SaveEnterpriseClientAndRenameSearchResponse);
        }
      })
      .catch((response) => {
        this.errorMessage = "Error while saving details, please try later.";
      })
      .finally(() => {
        this.loadingData = false;
      });

    return defer.promise;
  }

  getResultsPageUrl() {
    var url = "";
    switch (this.dealDetails.productFamily) {
      case ProductFamilyEnum.Bridging:
        url = `/e/bridgingresults/${this.$routeParams.uniqueRef}`;
        break;
      case ProductFamilyEnum.Commercial:
        url = `/e/commercialresults/${this.$routeParams.uniqueRef}`;
        break;
      case ProductFamilyEnum.Development:
        url = `/e/devfinanceresults/${this.$routeParams.uniqueRef}`;
        break;
      default:
        break;
    }
    return url;
  }

  showSignInModal() {
    if (!this.isWidget && !this.isMobileView && !this.iFrame) {
      this.enterpriseClient.userName = this.enterpriseClient.email;
      this.showEnterpriseRegistrationModal = true;
      this.showRegisterModal = true;
      this.showLoginSection = true;
      document.getElementById("body").style.overflow = "hidden";
    } else {
      this.saveEnterpriseClientAndRenameDeal(true).then((response) => {
        var redirectUrl = this.getLoginRedirectUrl();
        (this.$rootScope as any).loginRedirectPath = redirectUrl;
        this.goToLink(
          `/e/login/${this.dealDetails.productFamily}/${this.$routeParams.uniqueRef}/${this.dealDetails.clientId}/${this.enterpriseClient.email}`,
        );
      });
    }
  }

  onClickLogin() {
    this.login();
  }

  login() {
    this.loadingData = true;
    if (!this.$cookies.get("access_token")) {
      this.$auth
        .newLogin(this.enterpriseClient.userName, this.password, "CC022EBE67BE0424EA2A6548B062D2D71")
        .then((response) => {
          let expiry: Date = response;
          this.isLoginError = false;

          this.saveEnterpriseClientAndRenameDeal(true).then(() => {
            this.userClient.sendEventToHubspot({
              user: this.enterpriseClient,
              page: "ENTERPRISE-LEAD-LOGGEDIN-FROM-LEADCAPTURE-PAGE",
              login: false,
              orgCode: this.orgCode ?? "",
              role: UserRoleEnum.Client,
              organisationLinkId: this.dealDetails.organisationLinkId != null ? this.dealDetails.organisationLinkId : 0,
              productType: this.dealDetails.productType,
              dealId: this.dealDetails.dealId,
              developmentInputWithNoLoginUniqueRef: "",
              clientId: this.dealDetails.clientId,
              introducerString: "",
              isDeleted: false,
            } as HubspotContactRequest);

            // link user to the client record
            this.clientClient.updateClientWithUserId(this.dealDetails.clientId);

            this.$rootScope.$broadcast("login"); //tell everyone you have logged in
            var redirectUrl = this.getLoginRedirectUrl();
            this.$location.path(redirectUrl);
          });
        })
        .catch((response) => {
          this.isLoginError = true;
          this.password = null;
        })
        .finally(() => {
          this.loadingData = false;
        });
    } else {
      // User may have logged in on a different browser/tab
      this.saveEnterpriseClientAndRenameDeal(true).then(() => {
        var redirectUrl = this.getLoginRedirectUrl();
        this.$location.path(redirectUrl);
      });
    }
  }

  goToLink(url, isResultsLink = false) {
    var baseUrl = window.location.href.split("#!")[0] + "#!";
    this.newUrl = baseUrl + url;
    this.message = isResultsLink ? "view your results" : "sign in";

    if (isResultsLink) this.hasEnterpriseClient = true;

    var newWindow = window.open(this.newUrl, "_blank");

    if (!newWindow || newWindow.closed || typeof newWindow.closed === "undefined") {
      this.showMessageModal = true;
    }
  }

  openLink() {
    window.open(this.newUrl, "_blank");
    this.showMessageModal = false;
  }

  goToPreviousEnterprisePage() {
    if (this.enterpriseLinkType) {
      if (this.isWidget) {
        switch (Number(this.enterpriseLinkType)) {
          case LinkTypeEnum.Development:
            path =
              this.organisationLinkId != null
                ? `/allloans/${this.organisationLinkId}/widget/${LinkTypeEnum.Development}`
                : `/allloans/0/widget/${LinkTypeEnum.Development}`;
            break;
          case LinkTypeEnum.Bridging:
            path =
              this.organisationLinkId != null
                ? `/allloans/${this.organisationLinkId}/widget/${LinkTypeEnum.Bridging}`
                : `/allloans/0/widget/${LinkTypeEnum.Bridging}`;
            break;
          case LinkTypeEnum.Commercial:
            path =
              this.organisationLinkId != null
                ? `/allloans/${this.organisationLinkId}/widget/${LinkTypeEnum.Commercial}`
                : `/allloans/0/widget/${LinkTypeEnum.Commercial}`;
            break;
          case LinkTypeEnum.AllLoans:
            path =
              this.organisationLinkId != null ? `/allloans/${this.organisationLinkId}/widget` : `/allloans/0/widget`;
            break;
          default:
            break;
        }
        this.$location.path(path);
      } else {
        switch (Number(this.enterpriseLinkType)) {
          case LinkTypeEnum.Development:
            this.organisationLinkId != null
              ? this.$location.path(`/e/devfinancecriteria/0/${this.organisationLinkId}`)
              : this.$location.path("/e/devfinancecriteria");
            break;
          case LinkTypeEnum.Bridging:
            this.organisationLinkId != null
              ? this.$location.path(`/e/bridgingcriteria/0/${this.organisationLinkId}`)
              : this.$location.path("/e/bridgingcriteria");
            break;
          case LinkTypeEnum.Commercial:
            this.organisationLinkId != null
              ? this.$location.path(`/e/commercialcriteria/0/${this.organisationLinkId}`)
              : this.$location.path("/e/commercialcriteria");
            break;
          case LinkTypeEnum.AllLoans:
            var path = "/allloans";
            if (this.organisationLinkId != null) {
              path = `/allloans/${this.organisationLinkId}`;
            }
            this.$location.path(path);
            break;
          default:
            break;
        }
      }
    } else {
      if (this.isWidget) {
        this.$location.path(`/enterprise/${this.organisationLinkUniqueId}/widget`);
      } else {
        this.$location.path(`/enterprise/${this.organisationLinkUniqueId}`);
      }
    }
  }

  getLoginRedirectUrl(): string {
    var redirectUrl = "";

    switch (Number(this.enterpriseService.getProductFamily())) {
      case ProductFamilyEnum.Development:
        redirectUrl = `/devfinanceresults/${this.$routeParams.uniqueRef}`;
        break;
      case ProductFamilyEnum.Bridging:
        redirectUrl = `/bridgingresults/${this.$routeParams.uniqueRef}`;
        break;
      case ProductFamilyEnum.Commercial:
        redirectUrl = `/commercialresults/${this.$routeParams.uniqueRef}`;
        break;
      default:
        redirectUrl = "/userdashboard";
        break;
    }

    return redirectUrl;
  }

  /**Sends an email to the email address for the user to reset their password */
  sendResetPasswordEmail() {
    this.loadingData = true;
    this.userClient
      .resetForgottenPassword(this.enterpriseClient.email)
      .then((response) => {
        this.isLoginError = false;
        this.isResetPasswordSubmitted = true;
        this.registrationLoginError = null;
      })
      .catch((error) => {
        this.registrationLoginError = error;
      })
      .finally(() => {
        this.loadingData = false;
      });
  }

  footerSignInClicked() {
    var redirectUrl = this.getLoginRedirectUrl();
    if (this.projectName) {
      this.dealClient.renameDeal(this.$routeParams.uniqueRef, this.projectName).then(() => {
        (this.$rootScope as any).loginRedirectPath = redirectUrl;
        if (this.dealDetails) {
          this.goToLink(`/e/login/${this.dealDetails.productFamily}/${this.$routeParams.uniqueRef}`);
        } else {
          this.goToLink(`/e/login/${Number(this.enterpriseService.getProductFamily())}/${this.$routeParams.uniqueRef}`);
        }
      });
    } else {
      (this.$rootScope as any).loginRedirectPath = redirectUrl;
      this.goToLink(`/e/login/${Number(this.enterpriseService.getProductFamily())}/${this.$routeParams.uniqueRef}`);
    }
  }
}
